import { useDashboard, EnvironmentState } from '@wix/dashboard-react';
import { useEnvironment, useWix } from '@wix/sdk-react';
import React, { useState } from 'react';
import {
  WixPatternsDashboardBaseProvider,
  CairoProviderProps,
} from './CairoDashboardBaseProvider';
import { createEssentials } from '@wix/bex-utils/@wix/bex-bundled-mini-essentials';

export function WixPatternsDashboardProvider(props: CairoProviderProps) {
  const dashboard = useDashboard();
  const environment = useEnvironment<EnvironmentState>();
  const client = useWix();

  const [essentials] = useState(() => {
    return createEssentials({
      environment: {
        language: environment.locale,
        artifactId: '',
        version: '',
      },
      httpClient: {
        getAppToken: () => dashboard.getAccessToken(),
        baseURL: 'https://www.wixapis.com',
        isSSR: true,
      },
      experiments: {
        bag: {}, // app-level experiments are not supported in TPA
      },
    });
  });

  return (
    <WixPatternsDashboardBaseProvider
      {...props}
      dashboard={dashboard}
      environment={environment}
      client={client}
      essentials={essentials}
    />
  );
}
